import { render, staticRenderFns } from "./FacturasList.vue?vue&type=template&id=6ec2c203&scoped=true&lang=pug"
import script from "./FacturasList.vue?vue&type=script&lang=js"
export * from "./FacturasList.vue?vue&type=script&lang=js"
import style0 from "./FacturasList.vue?vue&type=style&index=0&id=6ec2c203&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec2c203",
  null
  
)

export default component.exports